const CSS_CLASSES = {
	ACTIONS: 'root__card__actions',
	CARD: 'root__card',
	CHECKBOX_CONTAINER: 'checkbox-list__container',
	CHECKBOX_ICON: 'checkbox-list__icon',
	CONTAINER: 'root__container',
	CONTROL: 'form-control',
	HIDDEN: 'root--hidden',
	INVALID: 'root--invalid',
	TITLE_BODY: 'title__body',
	TITLE_BODY_LIST: 'title__body__list',
	TITLE_BODY_LIST_ANCHOR: 'title__body__list__button--anchor',
	TITLE_BODY_LIST_NO_INDENT: 'title__body__list--no-marker',
	TITLE_BODY_WARNING_NO_INDENT: 'title__body__warning--no-marker',
	SUBLABEL: 'sublabel',
	USER_NETWORK_ID: 'user__network__id',
};

const OBJ_ACCOUNT_TYPES = {
	SHARED_CALENDAR: '6',
};

export { CSS_CLASSES, OBJ_ACCOUNT_TYPES };
